export default "__VITE_ASSET__DlW7IhQt__"